export default "__VITE_ASSET__c2d9891f__"